import script from "./ViewProfessionalDevelopmentSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewProfessionalDevelopmentSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ViewProfessionalDevelopmentSidebar.vue?vue&type=style&index=0&id=c8b14d42&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c8b14d42"]])

export default __exports__